const { default: requests } = require("../utils/http");

const route = "https://uq8elplp76.execute-api.us-east-1.amazonaws.com";

const shopifyApi = {
    newCustomer:(data) =>{
        return requests.post(route+"/shopify/customers", data)
    }
}

export default shopifyApi;